import ContentConfig from '../../config/ContentConfig';
import hasRequiredStateForInitialReport from './hasRequiredStateForInitialReport';
import logger from '../../log';
import { ReporterReadyInterface } from './interfaces';
import { ReporterState } from '../../state/LocalState';
import { use10Reporting } from './formatReportRequest';
const log = logger.getLogger(__filename);

export interface DurationData {
  duration?: unknown;
}

export const hasTimedOut = (reporter: ReporterReadyInterface): boolean => {
  const startTimeout = ContentConfig.getInstance().report.startTimeout;
  return Date.now() - reporter.state.startTime > startTimeout;
};

export const hasMinimalRequiredState = (
  reporter: ReporterReadyInterface
): boolean => {
  const {
    localState: { play },
    state
  } = reporter;
  return (
    hasToken(state, use10Reporting()) &&
    typeof play.contentId !== 'undefined' &&
    typeof play.playGuid !== 'undefined' &&
    typeof play.tenantId !== 'undefined'
  );
};

export const isStateInitialized = (state: ReporterState): boolean => {
  return (
    !state.hasSeenDuration ||
    !!state.reportIntervalId ||
    !state.hasReporterInitialized
  );
};

export const hasToken = (state: ReporterState, use10: boolean): boolean => {
  if (use10) {
    return true;
  }
  const { sessionToken, contentToken } = state;
  return !!sessionToken || !!contentToken;
};

// Has Required Data To Inital Report
const reporterIsReadyToStart = (reporter: ReporterReadyInterface): boolean => {
  const state = reporter.state;
  const localState = reporter.localState;
  if (isStateInitialized(state)) {
    return false;
  }
  if (hasRequiredStateForInitialReport(reporter)) {
    return true;
  }
  log.debug('all checks have failed', { play: localState.play, state });
  return false;
};

export default reporterIsReadyToStart;
